import { Snackbar, Alert } from '@mui/material';
import { createRoot } from 'react-dom/client';
// 创建用于显示消息的函数
export const showMessage = (message, severity = 'error') => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    
    const root = createRoot(container);
    root.render(
      <Snackbar
        open={true}
        autoHideDuration={1500} // 展示2秒后隐藏弹框
        onClose={() => {
          root.unmount();
          document.body.removeChild(container);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={severity} variant="filled">
          {message}
        </Alert>
      </Snackbar>
    );
  };
